import ActionBarItem from '@rio-cloud/rio-uikit/ActionBarItem';
import { useUikitContext } from '../UikitContext';
import Icon from '@rio-cloud/rio-uikit/Icon';

export const MenuToggle = () => {
    const { onMenuIconClicked, showMenu } = useUikitContext();

    return (
        <ActionBarItem id='menuToggle'>
            <ActionBarItem.Icon onClick={onMenuIconClicked}>
                <Icon iconName='menu-hamburger' iconClassName='UikitMenuToggle' />
            </ActionBarItem.Icon>
        </ActionBarItem>
    );
};
